<script>
    import HomeCourseCard from '../home/HomeCourseCard';
    import {Form} from '../../helpers/Form/Form'

    export default {
        components: {HomeCourseCard},
        data() {
            return {
                items: [],
                form: new Form({
                    id: Math.random(),
                    longitude: 12.496365500000024,
                    latitude: 41.90278349999999,
                    filters: {
                        municipality: 'Roma RM, Italia',
                        disabilities: [],
                        sports: []
                    }
                })
            }
        },
        mounted() {
            this.setFilters()

            this.getLocation()
        },
        methods: {
            setFilters() {
                let sports = this.getParameterByName('sports')
                let disabilities = this.getParameterByName('disabilities')

                if (!_.isEmpty(disabilities)) {
                    this.$set(this.form.filters, 'disabilities', disabilities.split(','))
                }
                if (!_.isEmpty(sports)) {
                    this.$set(this.form.filters, 'sports', sports.split(','))
                }
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");

                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);

                if (!results) return null;
                if (!results[2]) return "";

                return decodeURIComponent(results[2].replace(/\+/g, " "));
            },
            getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        this.returnPosition,
                        this.errorPosition
                    );
                }
            },
            async returnPosition(position) {
                this.$set(this.form, 'latitude', position.coords.latitude * 1)
                this.$set(this.form, 'longitude', position.coords.longitude * 1)

                this.fetchItems()
            },
            async errorPosition(error) {
                this.fetchItems()
            },
            fetchItems() {
                this.form
                    .get(route('filter.courses'))
                    .then(response => {
                        this.$set(this, 'items', _.take(response.results.data, 4))
                    })
            },
            onSearch() {
                let querystring = encodeURI(`filters=${JSON.stringify(this.form.filters)}&latitude=${this.form.latitude}&longitude=${this.form.longitude}`)

                let source = route('search.show')
                return window.open(`${source}?${querystring}`);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/widgets/WidgetDisabilitiesContainer.vue